import React from 'react'

const Title = ({title}) => {
  return (
    <div className='grid items-center'>
      <h1 className='text-5xl lg:4xl md:3xl sm:2xl filter drop-shadow-2xl font-semibold text-slate-800 '>{title}</h1>
    </div>
  )
}

export default Title